'use client';

import { useLevelTwoContext } from '@/feature-flags/providers/LevelTwoProvider';
import type { LevelTwoConfigKey } from '@/feature-flags/types/variant.types';

export interface FeatureValueResult {
  value: boolean;
  loading: boolean;
  isFallback: boolean;
  variant: string | null;
  error: Error | null;
}

export function useFeatureValue(feature: LevelTwoConfigKey): FeatureValueResult {
  const { config, loading, isFallback, variant, error } = useLevelTwoContext();

  return {
    value: config[feature] === true,
    loading,
    isFallback,
    variant,
    error,
  };
}
